import React, { Component } from 'react';
import styles from './Table.module.css';
import { restructureResponse,generateEmptyResponse,aggregateResultsByFirstParameter } from '../../helpers/sparql';


// import { Table as StrapTable } from 'reactstrap';

class Table extends Component {
  onClick = uri => {
    this.props.publish(this.props.publishVariable, uri);
  };

  render() {
    var data = this.props.data;
    if ((!this.props.data) || (this.props.data.results.bindings.length==0))
   {
     if (this.props.renderEmpty)
     {
      data =generateEmptyResponse(this.props.query);
     }
     else
     {
       return null;
     }
    }


   
    let headVars = data.head.vars;
    let items = restructureResponse(data);
    if (this.props.aggregateResultsByID)
    {
    
      items=aggregateResultsByFirstParameter(items,headVars[0]);
    }

    return (
      <div className={styles.main}>
        {this.props.title && <div className={styles.title}>{this.props.title}</div>}
        <table>
          <thead>
            <tr>
              {headVars.map((headVar, index) => {
                if (headVar.endsWith('URI')) return null;
                return <th key={index}>{headVar}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => {
              return (
                <tr key={index}>
                  {headVars.map((headVar, index) => {
                    if (headVar.endsWith('URI')) return null;

                    let value = item[headVar] || '';
                    let uri = item[headVar + 'URI'];

                    if (uri) {
                      return (
                        <td key={index} className={styles.link} onClick={() => this.onClick(uri)}>
                          {value}
                        </td>
                      );
                    } else {
                      return <td key={index}>{value}</td>;
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Table;
